import React, { useEffect, useState } from 'react';
import './DateField.css';

function isoToDisplay(iso) {
  if (!iso) return '';
  const parts = String(iso).split('-');
  if (parts.length !== 3) return '';
  const [y, m, d] = parts;
  return `${m}/${d}/${y}`;
}

function displayToIso(display) {
  const match = String(display).trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!match) return null;
  const mm = match[1].padStart(2, '0');
  const dd = match[2].padStart(2, '0');
  const yyyy = match[3];
  const check = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
  if (
    Number.isNaN(check.getTime())
    || check.getFullYear() !== Number(yyyy)
    || check.getMonth() + 1 !== Number(mm)
    || check.getDate() !== Number(dd)
  ) return null;
  return `${yyyy}-${mm}-${dd}`;
}

/**
 * Remplace <input type="date"> par un champ texte libre (MM/DD/YYYY, tapable
 * au clavier) + une icone calendrier qui ouvre le picker natif du navigateur/
 * telephone (un <input type="date"> invisible est superpose exactement sur
 * l'icone, donc c'est le VRAI controle natif qui recoit le tap/clic, fiable
 * sur tous les navigateurs sans dependre de showPicker()).
 *
 * Raison : sur mobile, <input type="date"> seul n'autorise QUE le picker natif
 * (roue/calendrier) — impossible de taper la date au clavier. Demande
 * explicite de l'utilisateur (2026-09-16) : garder le picker (clic/selection)
 * ET ajouter la saisie manuelle a cote.
 *
 * Contrat `value`/`onChange` identique a l'input natif qu'il remplace : ISO
 * "YYYY-MM-DD", `onChange` recoit directement la string (pas un event) — les
 * pages appelantes passent donc leur setter directement (`onChange={setDate}`).
 * `className` s'applique au champ texte visible (memes classes CSS qu'avant,
 * largeur/style inchanges).
 */
export default function DateField({ value, onChange, className = '' }) {
  const [text, setText] = useState(isoToDisplay(value));

  useEffect(() => {
    setText(isoToDisplay(value));
  }, [value]);

  const commit = (raw) => {
    const iso = displayToIso(raw);
    if (iso) {
      onChange(iso);
    } else {
      // Invalide/incomplet -> revient a la derniere valeur valide connue,
      // meme comportement de repli qu'un input type="date" natif.
      setText(isoToDisplay(value));
    }
  };

  return (
    <span className="df-wrap">
      <input
        type="text"
        inputMode="numeric"
        placeholder="MM/DD/YYYY"
        className={className}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={(e) => commit(e.target.value)}
      />
      <span className="df-icon-wrap">
        <span className="df-icon" aria-hidden="true">📅</span>
        <input
          type="date"
          className="df-native"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          aria-label="Ouvrir le calendrier"
        />
      </span>
    </span>
  );
}
